import React from 'react';
import '../styles/component.css';

const Loader = () => {
    return (
      <div className="loader">
        <div className="spinner"></div>
      </div>
    );
  };
  
  export default Loader;